import { render, staticRenderFns } from "./ModalEditUserAcademy.vue?vue&type=template&id=2891426c&scoped=true&lang=pug&"
import script from "./ModalEditUserAcademy.vue?vue&type=script&lang=ts&"
export * from "./ModalEditUserAcademy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2891426c",
  null
  
)

export default component.exports